import moment from "moment";

export const checkIfPresent = (visits = [], period) => {
  if (period === "morning") {
    return visits.some(visit => moment(visit.startDate).hour() < 12);
  } else {
    return visits.some(visit => moment(visit.endDate).hour() > 12);
  }
};



// WEBPACK FOOTER //
// src/modules/presence/utils/presence.utils.js